import { Button } from "@mui/material";
import React, { useCallback } from "react";
import { useActionRequest } from "../../../common/hooks/api";
import { Api } from "../../../common/service/Api";
import { GetCompliantPageWrapper } from "../../components/layout/GetCompliantPageWrapper";
import { usePrimaryOrganizationId } from "../../hooks";
import ConfettiComponent from "../../../common/components/Confetti";
import { InlineWidget } from "react-calendly";
import { Routes } from "../../root/routes";

export const Complete: React.FC = () => {
  const orgId = usePrimaryOrganizationId();

  // Requests
  const apiRequest = useCallback(() => Api.organization.setGetCompliantDone(orgId, true), [orgId]);

  const { fetch: transitionToStayCompliant } = useActionRequest({
    api: apiRequest,
    onSuccess: () => {
      window.location.href = Routes.dashboard.root;
    },
  });

  const handleClick = () => {
    transitionToStayCompliant();
  };

  return (
    <GetCompliantPageWrapper showNavSteps={false} fullWidth={true} disablePadding={true}>
      <div className="get-compliant-complete--header">
        <ConfettiComponent />
        <h1>Congratulations!</h1>
      </div>
      <div className="get-compliant-complete--container">
        <div className="get-compliant-complete--text-container">
          <p className="py-1">Well done! You completed your Data Map.</p>
          <p className="mt-xs mb-xl">
            {
              "Schedule your personalized walkthrough of our Continuous Compliance Service. On that call, we'll show you how to customize and launch your new Privacy Center."
            }
          </p>
          <div className="text-center mb-xl">
            <Button variant="contained" color="primary" onClick={handleClick}>
              Go to my Compliance Dashboard
            </Button>
          </div>

          <InlineWidget
            url="https://calendly.com/truevault-customer-success/support?hide_gdpr_banner=1&primary_color=5331C6&background_color=FFFFFF&text_color=1A1726"
            styles={{
              minWidth: "1400px",
              height: "700px",
              overflowX: "hidden",
              overflowY: "hidden",
              padding: "0",
              margin: "-66px 0 -55px 0", // Top and bottom margins adjusted. Left and right are set to 0
              transform: "translateX(-325px)", // Attempt to counteract internal left/right padding
              width: "calc(100% + 100px)", // Increase width to counteract the internal padding; adjust as necessary
            }}
          />
        </div>
      </div>
    </GetCompliantPageWrapper>
  );
};
